var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCirclesTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 563,
    height: 1585,
    viewBox: "0 0 563 1585",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M444.272 1003.82C456.911 1053.73 492.278 1095.42 545.493 1128.05C598.711 1160.68 669.751 1184.24 753.663 1197.89C921.484 1225.2 1140.69 1212.88 1371.49 1154.43C1602.29 1095.98 1800.94 1002.49 1935.54 898.601C2002.84 846.656 2054.1 792.126 2085.38 738.098C2116.65 684.073 2127.91 630.58 2115.27 580.667C2102.63 530.754 2067.27 489.069 2014.05 456.439C1960.83 423.806 1889.79 400.249 1805.88 386.595C1638.06 359.288 1418.85 371.61 1188.05 430.057C957.253 488.503 758.603 581.996 624.006 685.886C556.706 737.831 505.44 792.361 474.167 846.389C442.896 900.414 431.632 953.907 444.272 1003.82Z",
    stroke: "url(#paint0_linear_563_166)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.162 1084.12C144.611 1153.03 193.434 1210.56 266.863 1255.59C340.296 1300.62 438.309 1333.12 554.066 1351.95C785.577 1389.62 1087.96 1372.62 1406.33 1292C1724.69 1211.38 1998.72 1082.41 2184.4 939.095C2277.24 867.436 2347.97 792.205 2391.13 717.654C2434.28 643.107 2449.83 569.271 2432.38 500.364C2414.93 431.457 2366.11 373.923 2292.68 328.898C2219.25 283.871 2121.23 251.371 2005.48 232.536C1773.97 194.865 1471.58 211.865 1153.22 292.486C834.848 373.108 560.82 502.075 375.141 645.392C282.301 717.051 211.568 792.282 168.417 866.832C125.267 941.38 109.712 1015.22 127.162 1084.12Z",
    stroke: "url(#paint1_linear_563_166)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_563_166",
    x1: 2057.2,
    y1: 551.859,
    x2: 609.995,
    y2: 1152.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491388,
    stopColor: "#484848",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_563_166",
    x1: 2352.1,
    y1: 460.675,
    x2: 355.932,
    y2: 1288.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491388,
    stopColor: "#484848",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesTable);
export default __webpack_public_path__ + "static/media/circlesTable.36c91a78f9082e4c1cba06e3c80d2f5c.svg";
export { ForwardRef as ReactComponent };